import { observer } from "mobx-react-lite";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { useStore } from "../../common/stores";
import { useTaskTemplateStore } from "../stores/context";
import TaskTemplatesList from "../components/TaskTemplatesList";

const TaskTemplatesPage: React.FC = () => {
    const context = useTaskTemplateStore();
    const rootContext = useStore();
    const [searchParams] = useSearchParams();
    const projectId = searchParams.get("projectId");

    React.useEffect(() => {
        if (!projectId || context.store.selectedProjectId === projectId) {
            return;
        }

        context.store.setSelectedProjectId(projectId);
    }, [context.store, projectId]);

    return (
        <TaskTemplatesList
            store={context.store}
            projectsStore={rootContext.projectsStore}
        />
    );
};

export default observer(TaskTemplatesPage);
